<template>
  <div class="line-item line-item-free-gift">
    <img :src="sizedImageSrc" :alt="imageAlt" class="line-item-image" />
    <div class="line-item-text">
      <h4 class="line-item-title">{{ title }}</h4>
      <span class="line-item-subtitle">{{ subtitle }}</span>
    </div>
    <div class="line-item-cta">
      FREE GIFT
    </div>
  </div>
</template>

<script>
import * as ShopifyImage from '@shopify/theme-images';

export default {
  name: 'FreeGiftLineItem',
  props: {
    imageAlt: {
      default: '',
      type: String
    },
    imageSrc: {
      default: '',
      type: String
    },
    title: {
      default: '',
      type: String
    },
    subtitle: {
      default: '',
      type: String
    }
  },

  computed: {
    sizedImageSrc() {
      return ShopifyImage.getSizedImageUrl(this.imageSrc, '58x');
    }
  }
};
</script>
